import { QueryClient } from '@tanstack/react-query';

import { HttpError } from './http-error';

const MAX_QUERY_RETRIES = 2;

export const retryNetworkOrServerError = (failureCount: number, error: Error) =>
  failureCount < MAX_QUERY_RETRIES && (!(error instanceof HttpError) || error.status >= 500);

/**
 * Creates a QueryClient with the app's default cache behavior. Keep client
 * lifetime scoped by the caller: one instance per SSR request and one stable
 * instance for the browser app.
 *
 * `refetchOnWindowFocus` is disabled globally — including for wagmi-driven
 * queries — to avoid surprise refetches on tab focus. Opt back in per-hook
 * (e.g. `useWalletPortfolio`) when focus-driven refresh is actually desired.
 */
export const makeQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });
